export default "__VITE_ASSET__af1dd169__"